import React, { lazy } from 'react';

// Lazy-loaded page components (code-split per page)
const RolesManagementPage = lazy(() => import('./pages/RolesManagementPage'));
const ClientErrorsPage = lazy(() => import('./pages/clientErrors/ClientErrorsPage'));


export const bankAdminPages = (_displayName: string): Record<string, React.ReactNode> => ({
  bankRoleManagement: <RolesManagementPage />,
  clientErrors: <ClientErrorsPage />,
});
